var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReplyArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CED4DA",
    d: "M0 0h1v9H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37 16.678c-.216-.194-.216-.516 0-.73l1.868-1.87H.516A.496.496 0 010 13.563V8.578c0-.28.215-.515.516-.515.279 0 .515.236.515.515v4.469h8.207l-1.869-1.87c-.215-.193-.215-.515 0-.73a.506.506 0 01.71 0l2.75 2.75a.53.53 0 01.171.366c0 .15-.065.279-.172.365l-2.75 2.75a.47.47 0 01-.709 0z",
    fill: "#CED4DA"
  })));
}
export default SvgReplyArrow;